import { useEffect, useReducer } from "react";
import GenericModal from "../CommonComponents/genericModal/GenericModal";

import styles from "./users-and-roles.module.css";
import { UserEditForm } from "./UserEditForm";
import { RegionSelection, SubregionSelection } from "./OrganizationSelection";

export const EDIT_MODAL_ACTIONS = {
  SELECT_REGION: "SELECT_REGION",
  SELECT_SUBREGION: "SELECT_SUBREGION", 
  EDIT_FORM: "EDIT_FORM",
}

const initialModalState = {
  editForm: true,
  regionSelection: false,
  subregionSelection: false,
}

const modalReducer = (state, action) => {
  switch (action.type) {
    case EDIT_MODAL_ACTIONS.SELECT_REGION:
      return { regionSelection: true, subregionSelection: false, editForm: false };
    case EDIT_MODAL_ACTIONS.SELECT_SUBREGION:
      return { regionSelection: false, subregionSelection: true, editForm: false };
    case EDIT_MODAL_ACTIONS.EDIT_FORM:
      return { regionSelection: false, subregionSelection: false, editForm: true };
    default:
      return state;
  }
}

export const EDIT_USER_ACTIONS = {
  UPDATE_USER: "UPDATE_USER",
  RESET_USER: "RESET_USER"
}

const userReducer = (state, action) => {
  switch (action.type) {
    case EDIT_USER_ACTIONS.UPDATE_USER:
      return { ...state, ...action.payload };
    case EDIT_USER_ACTIONS.RESET_USER:
      return {};
    default:
      return state;
  }
}

const UserEditModal = ({ open, onClose, user }) => {
  const [modalState, modalDispatch] = useReducer(modalReducer, initialModalState);
  const [editUser, userDispatch] = useReducer(userReducer, {});

  useEffect(() => {
    if (user) {
      userDispatch({ 
        type: EDIT_USER_ACTIONS.UPDATE_USER, 
        payload: {
          id: user.getId(),
          name: user.getName(),
          email: user.getEmail(),
          roleId: user.getRoleId(),
          administratorLevel: user.getAdministratorLevel(),
          accessId: user.getAccessId(),
          isActive: user.getIsActive(),
          accessLevel: user.getAccessLevel(),
        }
      });
    } else {
      userDispatch({ type: EDIT_USER_ACTIONS.RESET_USER });
    }
  }, [user]);

  const handleClose = () => {
    setTimeout(() => {
      modalDispatch({ type: EDIT_MODAL_ACTIONS.EDIT_FORM });
    }, 100);
    onClose();
  }

  return (
    <GenericModal open={open} onClose={handleClose} backdropClassName={styles.modalBackdrop} modalClassName={styles.inviteModal}>
      {modalState.editForm && <UserEditForm onClose={handleClose} user={editUser} userDispatch={userDispatch} modalDispatch={modalDispatch} />}
      {modalState.regionSelection && <RegionSelection onClose={handleClose} user={editUser} modalDispatch={modalDispatch} usersDispatch={userDispatch} isEditMode={true} />}
      {modalState.subregionSelection && <SubregionSelection onClose={handleClose} user={editUser} modalDispatch={modalDispatch} usersDispatch={userDispatch} isEditMode={true} />}
    </GenericModal>
  )
}

export default UserEditModal;
